
import './suppressLogs'; // Add this first to suppress console.log() .. in prod
import { Auth0Provider } from '@auth0/auth0-react';
import { createBrowserHistory } from "history";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PrimeReactProvider } from 'primereact/api';
import App from './App';
import './assets/css/style.scss';
import './index.scss';
import reportWebVitals from './reportWebVitals';
const history = createBrowserHistory();

const onRedirectCallback = (appState: any) => {
    history.push(
      appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <PrimeReactProvider>
        <Auth0Provider
            domain={`${process.env.REACT_APP_AUTH0_DOMAIN}`}
            clientId={`${process.env.REACT_APP_AUTH0_CLIENT_ID}`}
            onRedirectCallback={onRedirectCallback}
            authorizationParams={{
                redirect_uri: window.location.origin+process.env.REACT_APP_BASE_PATH
            }}
        >
            <ToastContainer
                position='top-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
            />
            <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
                <App />
            </BrowserRouter>
        </Auth0Provider>
        </PrimeReactProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
